<section class="relative">
  <button (click)="toggleMenu($event)" [closeOnOutSide]="isMenuOpen" (clickedOutside)="isMenuOpen = false" class="outline-none cursor-pointer">
    <img [src]="user | avatarSize: 'm'" class="rounded-full h-8 w-8 inline-block" alt="avatar" />
    <div class="hidden md:inline-block pl-2 ">{{ user.name ? user.name : user.firstname }}</div>
  </button>
  <div *ngIf="isMenuOpen" class="flex flex-col z-50 -right-4 md:right-28 top-16 md:top-20 absolute">
    <div id="frist_div" class="w-72 h-12 bg-primary rounded-b-none rounded-2xl shadow"></div>
    <div class="w-72 h-12 bg-white color-border border-b shadow">
      <a [routerLink]="['/profile']" class="outline-none w-full">
        <img [src]="user | avatarSize: 'm'" class="bg-primary p-1 left-5 top-5 rounded-full h-16 w-16 inline-block absolute" alt="IMG_User" />
        <div class=" pl-20 ml-3 mt-1 text-gray-700">{{user.name ? user.name : user.firstname }}</div>
        <div class="text-xs pl-20 ml-3 ">{{ user.email }}</div>
      </a>
    </div>
    <div class="w-72 h-12 bg-white color-border border-b shadow">
      <div class="py-2 flex pl-12 items-center">
        <fa-icon class="text-xl" [icon]="faIcon.faUser"></fa-icon>
        <div class=" pl-8 text-gray-700 cursor-pointer" [routerLink]="'/profile'">Cài đặt tài khoản</div>
      </div>
      <div class="py-2 flex pl-10">
        <a [routerLink]="'/b/GYlepn'" class="text-xs pl-10 ml-3 mt-1 text-gray-700">{{ version }} {{ timestamp }}</a>
      </div>
    </div>
    <!-- <div class="w-80 h-12 bg-white rounded-t-none shadow border-gray-400 border-b">
      <div class="py-2 flex pl-10 ml-1">
        <fa-icon [icon]="faIcon.faInfoCircle" class="text-2xl cursor-pointer"></fa-icon>
        <a class="outline-none text-xs text-gray-700 sm: block link dim font-medium black ml-6 mt-1 cursor-pointer" [routerLink]="['/profile']"
          routerLinkActive="router-link-active">Hồ sơ</a>
      </div>
    </div> -->
    <div class="w-72 h-12 bg-white rounded-t-none rounded-lg shadow">
      <div class="py-2 flex pl-10 ml-1">
        <!-- <fa-icon [icon]="faIcon.faSignOutAlt" class="text-2xl cursor-pointer"></fa-icon> -->
        <img class="h-8 opacity-90" src="/frontend-assets/images/free-exit-logout-icon-2857-thumb.webp" />
        <div (click)="signoutEvent.emit(); isMenuOpen = false"
          class="outline-none text-xs text-gray-700 sm: block link dim font-medium black ml-6 mt-1 cursor-pointer">
          Đăng xuất
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <pre> {{ user | json }} </pre> -->